import api from "./api";

export function getAgeList() {
  return api.apiCall("GET", "/api/v1/products-config/age/list");
}

export function getProductList() {
  return api.apiCall("GET", `/api/v1/products-hub/health/website/product/list`);
}

export function getProviderList() {
  return api.apiCall(
    "GET",
    `/api/v1/products-hub/health/website/provider/list`
  );
}

export function getPackageList(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/packages/list",
    data
  );
}

export function getPackageDetail(benefitsDetailUidList, infoFilter, gender) {
  return api.apiCall(
    "POST",
    `/api/v1/products-hub/health/website/packages/detail?benefitsDetailUidList=${benefitsDetailUidList}&infoFilter=${infoFilter}&gender=${gender}`
  );
}

export function getPackageFee(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/packages/gc/calculate/fees",
    data
  );
}

export function getDetailByPackagesUid(packagesUid, infoFilter, gender) {
  return api.apiCall(
    "POST",
    `/api/v1/products-hub/health/website/packages/detail?packagesUid=${packagesUid}&infoFilter=${infoFilter}&gender=${gender}`
  );
}

export function createOrder(data) {
  return api.apiCall("POST", `/api/v1/products-hub/order/create`, data);
}

export function getOTP(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/get-otp",
    data
  );
}

export function verifyOTP(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/verify-otp",
    data
  );
}

export function createInfoCustomer(data) {
  return api.apiCall(
    "POST",
    `/api/v1/products-hub/health/website/customer`,
    data
  );
}

export function consulting(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/consultation-appointments",
    data
  );
}

export function customerViews(data) {
  return api.apiCall("POST", "/api/v1/products-hub/customer-views", data);
}

export function uploadImage(data) {
  return api.apiUpload("POST", "/upload", data);
}

export function getBannerImages() {
  return api.apiCall("GET", "/api/v1/products-hub/banners?limit=10&page=1");
}

export function getProvinces() {
  return api.apiCall("GET", "/api/v1/products-hub/health/website/province");
}

export function getDistricts(provinceId) {
  return api.apiCall(
    "GET",
    `/api/v1/products-hub/health/website/province/${provinceId}/district`
  );
}

export function getFeeFromProvider(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/packages/provider/calculate/fees",
    data
  );
}

export function getListVoucher(data) {
  return api.apiCall(
    "POST",
    "/api/v1/products-hub/health/website/voucher/list",
    data
  );
}

export function getPartnerUser(userId, typeId) {
  return api.apiCallPartner(
    "GET",
    `/api/v1/products-hub/health/website/partner/globedr/info/${userId}?type=${typeId}`
  );
}

export function createOrderPartner(data) {
  return api.apiCallPartner("POST", `/api/v1/products-hub/order/create`, data);
}

export function createShareContent(data) {
  return api.apiCallPartner("POST", `/api/v1/products-hub/health/website/share-context`, data);
}

export function getShareContent(slug, id) {
  let route = `/api/v1/products-hub/health/website/share-context`;
  if (slug && id) {
    route = `/api/v1/products-hub/health/website/share-context?slug=${slug}&id=${id}`;
  }
  return api.apiCallPartner("GET", route);
}

export function getStime() {
  return api.apiCallOpenService("GET", "/v1/products/stime");
}

export function getDetailCollaborator(data, headers) {
  return api.apiCallOpenService("GET", `/v1/products/collaborator-detail`, data, headers);
} 
